/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import ModerationAcceptedNotificationDumb from './ModerationAcceptedNotificationDumb';
import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';
import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  notification: Notification,
};

const mapStateToProps = (state: State, { notification }: Props): Object => ({
  notification,
});

const mapDispatchToProps = (
  dispatch: any,
  { notification }: Props,
): Object => ({
  handleDismiss() {
    dispatch(dismissNotification(notification));
  },
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ModerationAcceptedNotificationDumb,
);
